import { render, staticRenderFns } from "./ReservationCalendar.vue?vue&type=template&id=c081445c&lang=pug"
import script from "./ReservationCalendar.vue?vue&type=script&lang=js"
export * from "./ReservationCalendar.vue?vue&type=script&lang=js"
import style0 from "./ReservationCalendar.vue?vue&type=style&index=0&id=c081445c&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports